import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-additionals-currentplan',
  templateUrl: './additionals-currentplan.component.html',
  styleUrls: ['./additionals-currentplan.component.sass']
})
export class AdditionalsCurrentplanComponent implements OnInit {
  @Input() equ_descr;
  @Input() instal_equi;
  @Input() cuo_val;
  @Input() addi_serv;
  constructor() { }

  ngOnInit() {
  }

}
